module.exports = __webpack_public_path__ + "static/media/achievement.b3d99592.svg";